import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

export const PLAN_PASSWORD = "test123!";
const STORAGE_KEY = "plan_pwd_ok";

const planApi = axios.create({
  baseURL: API_BASE,
  headers: {
    "Content-Type": "application/json",
    "X-Plan-Password": PLAN_PASSWORD,
  },
});

export const isPlanUnlocked = () => {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
};

export const tryUnlockPlan = (pwd) => {
  if (pwd === PLAN_PASSWORD) {
    try {
      sessionStorage.setItem(STORAGE_KEY, "1");
    } catch {}
    return true;
  }
  return false;
};

export const lockPlan = () => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {}
};

export const listPlanTasks = () => planApi.get("/plan/tasks");
export const createPlanTask = (data) => planApi.post("/plan/tasks", data);
export const updatePlanTask = (id, data) => planApi.patch(`/plan/tasks/${id}`, data);
export const deletePlanTask = (id) => planApi.delete(`/plan/tasks/${id}`);
export const seedPlanTasks = () => planApi.post("/plan/seed");
export const resetPlanTasks = () => planApi.post("/plan/reset");
export const syncPlanTasks = () => planApi.post("/plan/sync");
